import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck}=FiIcons;

const ObjectionBust=()=> {
  const objections=[
    "I'm not tech-savvy enough for AI",
    "I don't have time to learn new skills",
    "AI tools are too expensive for my budget",
    "I'm worried about job security with AI",
    "The technology changes too fast to keep up",
    "I prefer learning from people my own age",
    "I need to see immediate practical results",
    "I don't want to sit through hours of videos",
    "I'm concerned about data privacy and security",
    "I need support when I get stuck"
  ];

  const navigateToCourse=()=> {
    window.open('https://swiy.co/hYor','_blank','noopener,noreferrer');
  };

  return (
    <section className="py-16 bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 dark:text-white mb-4">
            We've Got You Covered
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-300">
            Every concern you have,we've addressed in GenXDojo
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {objections.map((objection,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,x: -30}}
              whileInView={{opacity: 1,x: 0}}
              transition={{duration: 0.5,delay: index * 0.1}}
              viewport={{once: true}}
              className="flex items-center bg-green-50 dark:bg-green-900/20 p-4 rounded-lg"
            >
              <SafeIcon icon={FiCheck} className="w-6 h-6 text-green-600 dark:text-green-400 mr-4 flex-shrink-0" />
              <span className="text-slate-800 dark:text-slate-200">{objection}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.5}}
          viewport={{once: true}}
          className="text-center mt-16 bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 p-8 rounded-xl border-2 border-amber-200 dark:border-amber-800"
        >
          <h3 className="text-2xl font-bold text-slate-800 dark:text-white mb-4">
            Still Not Sure? Here's Our Risk-Free Promise
          </h3>
          <p className="text-lg text-slate-700 dark:text-slate-300 mb-6">
            Try GenXDojo for 30 days. If you don't save at least 5 hours per week using our AI techniques,we'll refund every penny. No questions,no hassle.
          </p>
          <button
            onClick={navigateToCourse}
            className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200"
          >
            Start Your Risk-Free Trial
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ObjectionBust;